import { isAdminApp, isEmbedded } from '~/public/lib/PageHelpers.js';
import Modal from '~/components/Modal';
import { XMarkIcon } from '@heroicons/react/24/outline/index.js';
import React from 'react';

const ModalContainer = ({
    children,
    isOpen,
    onClose,
    widthClass = 'sm:max-w-[700px]',
    panelClassName,
}) => {
    if (isAdminApp() || !isEmbedded()) {
        // Use a real modal
        return (
            <Modal
                isOpen={isOpen}
                onClose={onClose}
                widthClass={widthClass}
                panelClassName={panelClassName}
            >
                {children}
            </Modal>
        );
    } else if (isOpen) {
        return (
            <div>
                <div className="fixed inset-0 z-40 w-screen overflow-y-auto">
                    <div
                        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
                        aria-hidden="true"
                        onClick={onClose}
                    />
                </div>
                <div
                    className={`absolute z-50 left-0 bg-white shadow-xl rounded-[23px] p-6 text-left transition-all sm:my-8 w-full ${widthClass} sm:mx-16 sm:p-6`}
                >
                    <button
                        className="btn-gray-link absolute right-5 top-5"
                        onClick={onClose}
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                    {children}
                </div>
            </div>
        );
    }
};

export default ModalContainer;
